// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"irisToast_snackbar__1QNZl","show":"irisToast_show__1N6Qw","fadein":"irisToast_fadein__1RYIy","fadeout":"irisToast_fadeout__2kpUb"};